export default {
    txt_welcome: 'ようこそ',
    txt_dataover: 'データ一覧',
    txt_chance: '機会',
    txt_device: '装置',
    txt_chinese: '中文',
    txt_english: 'English',
    txt_malay:'Bahasa Melayu',
    txt_german:'Deutsch',
    txt_french:'Français',
    txt_italian:'Italiano',
    txt_spanish:'Español',
    txt_japan:'日本語',
    txt_reports: '記録を検出する',
    txt_setting: '設置',
    txt_dymanager: '店員管理',
    txt_account: 'アカウント',
    txt_userstatus: 'ユーザーID',
    txt_name: '氏名',
    txt_contactway: '連絡先',
    txt_accountsafe: 'アカウントのセキュリティ',
    txt_basicinfo: '基本情報',
    txt_updatepassword: 'パスワード変更',
    txt_storeinfomation: '店の情報',
    txt_storename: '店名',
    txt_storephone: '店の電話',
    txt_storeaddress: '店の住所',
    txt_AppInfomation: 'App信息',
    txt_currentversion: '当前版本',
    txt_software: 'ソフトウェア更新',
    txt_loginout: 'ログアウト',
    txt_updatelanguage: '言語を選んでください',
    txt_updateto: 'に更新',
    txt_zwgx: '更新なし',
    txt_dz: '店長',
    txt_sh: '商户',
    txt_dy: '店员',
    txt_bdsj: '電話をバインドする',
    txt_shxx: '取引先情報',
    txt_shname: '商户名称',
    txt_ssmd: '所属门店',
    txt_bdsb: '绑定设备',
    txt_mendian: '门店',


    //数据总览模块
    txt_sTime: '选择时间查询',
    txt_car_check: '車の点検率',
    txt_findchance: '機会を見つける',
    txt_trackchace: '機会追跡',
    txt_transform: '変換率',
    txt_TotalData: '总体数据',
    txt_xxsj: '詳しいデータ',
    txt_zhsj: '转化数据',
    txt_TireWear: '轮胎磨损',
    txt_DataHopper: 'データのファネル',
    txt_jdcc: '来店車両の延べ台数',
    txt_CheckCar: '点検台数',
    txt_ChanceNum: '机会数',
    txt_TrackNum: '追跡の数',
    txt_TranseformNum: '変換数',
    txt_UnTrack: '未追跡',
    txt_l: '台',
    txt_Time: 'じかん',
    txt_Device: 'せつび',
    txt_car_plate: 'ナンバープレート',
    txt_Wear: '摩耗',
    txt_Pwear: '偏磨',
    txt_NoData: 'データなし',
    txt_GoodState: '良好な状態',
    txt_Border: '境界状態',
    txt_replace: 'すぐ取り替える',
    txt_Total_Check: '点検された車両の延べ台数',
    txt_pmqk: '偏摩耗状況',
    txt_LightWear: '軽度の偏摩耗',
    txt_GraveWear: '重度の偏摩耗',
    txt_hwtj: '置き換え統計',
    txt_wxhw: '位置交換不要',
    txt_xyhw: '位置交換必要',
    txt_jcxq: '検査の詳細',
    txt_zhxq: '変換詳細;',
    txt_cc: '車',
    txt_bfb: '%',
    txt_ltxs: 'タイヤ販売;',
    txt_sldw: '四輪アライメント',
    txt_ddlph: '位置交換&ダイナミックバランス',
    txt_dphhh: 'ダイナミックバランス',
    txt_qt: 'ほか',
    txt_zhqs: '変換傾向',
    txt_ltxl: 'タイヤ販売台数',
    txt_ltfw: 'タイヤサービス',
    txt_ckxq: '詳細を調べる',
    txt_jt: 'きょうび',
    txt_zt: 'きのう',
    txt_bz: '今週',
    txt_by: 'ほんげつ',
    txt_sy: '先月',
    txt_jn: 'こんねん',
    txt_zhcl: '転化車両',
    txt_zhl: 'コンバージョン率',
    txt_bfb: '%',
    txt_abjx: '「境界」状態のタイヤの数',
    txt_aljg: '「今すぐ交換必要」状態のタイヤの数',
    txt_qwpm: '「軽度の偏摩耗」状態のタイヤの数',
    txt_ayzp: '「ひどい摩耗」状態のタイヤの数',
    txt_lingt: '0条',
    txt_yt: '1条',
    txt_et: '2条',
    txt_st: '3条',
    txt_ft: '4条',
    txt_symd:'全店',

    //机会
    txt_xsjh: '販売機会',
    txt_gzz: '追跡中:',
    txt_clwb: '処理終了',
    txt_ckbg: '報告書を見る',
    txt_yxs: 'すべてのデータが表示されました',
    txt_zhuiz: '追跡する',
    txt_tix: 'に注意',
    txt_chuli: '処理',
    txt_yzh: '変換された：',
    txt_wzh: '未転化',
    txt_gzsmts: '{0}の点検で問題が発生した　{1}に店に来て点検する予定',
    txt_czbty: '車の所有者が同意しません',
    txt_yyx: '意向がある',
    txt_ltyg: 'タイヤ1つ',
    txt_ltkg: 'タイヤ2つ',
    txt_ltsang: 'タイヤ3つ',
    txt_ltsig: 'タイヤ4つ',
    txt_jhcl: '機会の処理',
    txt_jhztai: '機会状態',
    txt_crquy: '責任区域',
    txt_chuliry: '処理者',
    txt_chulijg: '処理結果',
    txt_zhuanhuanr: '変換内容',
    txt_zhuanhuaje: '変換金額',
    txt_zhuanhuasj: '変換時間',
    txt_zhuanhuayx: '転化の意向',
    txt_xuanzesj: '時間を選ぶ',
    txt_tsdatawk: '機会の状態が空なので、データを保存できません',
    txt_qtxzhsj: '予想される変換時間を入力してください',
    txt_qtxzhnr: '変換の内容を記入してください',
    txt_qtxzhsj: '変換の時刻を記入してください',
    txt_sbts: 'データの保存に失敗しました。ネットワークを確認してください',



    //设备
    txt_sbgl: '設備管理',
    txt_tj: 'ついか',
    txt_gdssb: '合計{0}台の装置',
    txt_sbbh: '設備番号',
    txt_gjbb: 'ファームウェアバージョン',
    txt_tjsj: '時間追加',
    txt_zdgx: '自動更新',
    txt_gxgj: 'ファームウェアを更新する',
    txt_jieb: 'バインド解除',
    txt_sbtsxx: 'デバイスのファームウェアには新しいバージョンがあります。[ファームウェアの更新]ボタンをクリックして更新してください',
    txt_wjh: '未活性化',
    txt_lix: 'オフライン',
    txt_zaix: 'オンライン',
    txt_guz: 'こしょう',
    txt_yijieb: 'バインドを解除しました',
    txt_yihuis: '回収されました',
    txt_gxsbgj: 'デバイスのファームウェアを更新する',
    txt_gxsbgjts: 'デバイスのファームウェアを更新することを確認しますか',
    txt_socketdk: 'サーバー通信との接続が確立していないので、再試行してください',
    txt_cscgts: 'ファームウェアの更新要求が送信されました',
    txt_jbsb: '着脱装置',
    txt_jbsbts: '装置の着脱は確実か',
    txt_tscg: '操作に成功する',
    txt_zdgxgj: 'ファームウェアの自動更新',
    txt_gxgjts: 'デバイスの自動更新ファームウェア機能を決定しますか??',
    txt_beiz: '備考',
    txt_qtxbz: '備考を記入してください',
    txt_bdsbts: 'このAPPはの装置にのみ適用されます。バインドする装置のモデルが正しいことを確認してください',
    txt_qdksb: 'まず装置の電源を入れてください',
    txt_dksbts1: '1、新装置の場合、起動後、自動的にバインディングガイドに入ります',
    txt_dksbts2: '2、この装置が以前に他の店にバインドされたことがある場合は、まず装置の[設定]メニューで[装置のバインド解除]をクリックしてバインドを解除してください。バインドが解除されると、装置は自動的にバインディングガイドに入ります',
    txt_dksbts3: '2、デバイスが他の店舗と結び付けられたことがある場合は、アプリの「デバイス管理」メニューからデバイスの紐付け解除をクリックして紐付け解除を行います。紐付け解除後、デバイスが自動的に紐付け案内に入ります。',
    txt_yjdksblw: '装置の電源を入れてインターネットに接続しました',
    txt_xyb: '下一步',
    txt_qsclj: '手持ち式装置でQRコードをスキャンして装置に接続されると',
    txt_qscts1: '「ぶう」という音が鳴り',
    txt_qscts2: 'スキャンが成功したことを通知します',
    txt_sbtssmcg: '装置は既にスキャンが成功したことを示している',
    txt_ddsblw: '装置がインターネットに接続するのを待ちます',
    txt_zznlbd: 'デバイスを結びつけるために努力しています',
    txt_qszdd: 'これには数十秒かかる場合があります。しばらくお待ちください',
    txt_bdcg: 'バインディング成功',
    txt_tjcg: '成功を加える',
    txt_tjcgts: '追加されました。装置を識別しやすくするために、備考名を入力してください',
    txt_fhsblb: '装置リストに戻る',
    txt_jxtjsb: '装置の追加を続ける',
    txt_bzmc: '注記名称',
    txt_smsbts: 'スキャン結果が得られない',

    //检测记录
    txt_sx: '選別',
    txt_khsj: '顧客の携帯電話',
    txt_cphm: 'ナンバープレート',
    txt_cphm1: 'ナンバープレート',
    txt_clxh: '車両の型式',
    txt_xgbz: '備考訂正',
    txt_gtfjl: '合計{0}部の記録',
    txt_jcsj: '測定時間',
    txt_jcsj1: '測定時間',
    txt_xzkssj: '開始時刻を選ぶ',
    txt_xzjssj: '終了時刻を選ぶ',
    txt_jcjg: '検査結果',
    txt_msqk: '摩耗状況',
    txt_jygh: '交換を薦める',
    txt_zysh: '損耗に注意する',
    txt_zcsy: '普通に使う',
    txt_zc: '正常',
    txt_cz: 'リセット',
    txt_qd: '确定',
    txt_jcjgd: '検査結果',
    txt_msqkd: '摩耗状況',
    txt_sldwd: 'ていい',
    txt_jyghd: '交換を薦める',
    txt_zysh: '損耗に注意する',
    txt_zcsyd: '普通に使う',
    txt_xdwd: 'ポジショニングが必要',
    txt_xzyd: '注意を要する',
    txt_zcd: '正常',
    txt_bgxq: 'レポートの詳細',
    txt_ljdy: 'プリンターに接続する',
    txt_fwmd: 'サービス店',
    txt_mddz: '店舗の住所',
    txt_jcsb: '検査設備',
    txt_ddmd: '目的の店に行きます',
    txt_lic: 'マイレージ',
    txt_chex: '車種',
    txt_jcjyi: '検査提案',
    txt_ysbs: '色記述',
    txt_ztms: '全体磨耗',
    txt_hwms: '異常摩耗',
    txt_dqscjltx: '現在のブレーキ距離アラーム',
    txt_bgxqts: ' 備考:このテストは独立テストセンター天津自働車検測センターが行った。使用車両はアウディブランドFV7203BECGB型乗用車で、タイヤ規格は245/40 R18、タイヤ充填圧力は前タイヤ230kpa、后タイヤ220kpa。試験場所は、カダック塩城試験地。計算された車両の制動距離の速度範囲:100キロ/時から0キロ/時まで減速する。',
    txt_wxsmgz: '微信掃コード注目',
    txt_hwmsjh: '良好',
    txt_zqlun: '左前輪',
    txt_zhlun:'左後輪',
    txt_yqlun:'右前輪',
    txt_yhlun:'右後輪',
    txt_pingjunzhi: '平均値:',
    txt_guige: '規格',
    txt_gongli: 'キロメートル',
    txt_ltwjc: 'タイヤ未検出',
    txt_pinpai: 'ブランド',
    txt_ltws: 'タイヤの外観',
    txt_sewmts: 'QRコードをスキャンして\nレポートをチェックする',
    txt_print: 'Print',

    //店员管理
    txt_xz: '新たに',
    txt_qy: 'きょうようのかいし',
    txt_qyz: '稼働中',
    txt_ty: '使用停止',
    txt_yhzh: 'ユーザーアカウント',
    txt_lxfs: '連絡先',
    txt_cjsj: '作成時間',
    txt_bjxx: '情報を編集する',
    txt_xgmm: 'パスワードを変更する',
    txt_bgzt: 'アカウント状態の変更',
    txt_qdytjm: 'アカウント{0}{1}を確定しますか?',
    txt_tjdy: '店員を追加する',
    txt_bjdyxx: '店員情報を編集する',
    txt_zhxx: 'アカウント',
    txt_ygxm: '従業員の名前',
    txt_qtxygxm: '従業員の氏名を記入してください',
    txt_lxdh: '連絡用電話',
    txt_qtxyglxdh: '連絡用電話を記入してください',
    txt_dxyzm: '携帯確認コード',
    txt_qtxdxyzm: '携帯確認コードを記入してください',
    txt_fsdx: '携帯メール送信',
    txt_tjzh: 'アカウントを追加する',
    txt_baocun: 'ほぞん',
    txt_gtgygzh: '合計{0}の従業員アカウント',


    //登录
    txt_qdytcdlm: 'ログアウトは確定ですか',
    txt_qx: 'とりけし',
    txt_dl: 'ログイン',
    txt_qsrzh: 'アカウントや携帯電話番号を入力してください',
    txt_qsrmm: 'パスワードを入力してください',
    txt_zcshzh: '加盟店のアカウントを登録する',
    txt_shzhwjmm: '商人のアカウントがパスワードを忘れる',
    txt_yzdqmm: 'パスワード検証',
    txt_szxmm: '新しいパスワードの設定',
    txt_xgcg: '変更完了',
    txt_qtxjmm: '古いパスワードを記入してください',
    txt_yzzcsj: '登録済みの電話を確認する/邮箱',
    txt_qtxxmm: '新しいパスワードを書いてください',
    txt_qzctxxmm: 'パスワードをもう一度入力してください',
    txt_lcmmsrbyz: 'パスワードの入力が2回一致しない',
    txt_gxnxgcg: '新しいパスワードの変更が完了しました',
    txt_qljndxmm: '新しいパスワードを覚えておいてください',
    txt_fhgrzx: 'ホームページに戻る',
    txt_fsyzm: '確認コード送信',
    txt_qtxzcsjh: '携帯番号・メールアドレスをご記入ください',
    txt_qtxtxyzm: '図形認証コードを記入してください',
    txt_qsryzm: '確認コードを入力してください',
    txt_qszhhmm: '6-18桁の数字とアルファベットの新しいパスワードを入力してください',
    txt_qzcsrmm: 'パスワードをもう一度入力してください',
    txt_lcmmbyz: 'パスワードの入力が2回一致しない',
    txt_hdsy: 'トップページに行く',
    txt_zcshh: '加盟店番号',
    txt_fhdl: 'ログインに戻る',
    txt_wlqqsb: 'ネットワークのリクエストが失敗した場合は再試行してください',
    txt_wczc: '登録完了',
    txt_wsts: '始める前に、あなたのビジネス情報を完成させてください',
    txt_qtxshmc: '事業者名を記入してください',
    txt_shmc: '取引先名',
    txt_rgszjd: '会社の固定電話、他の電話、ファックスなど',
    txt_qtlxfs: '他の連絡方法',
    txt_kssy: '使い始める',
    txt_Pwear1: '偏磨',
    txt_open: '打开',
    txt_close: 'しめいかいひ',
    txt_srczhdmm: 'リセットしたパスワードを入力する',
    txt_kcfs: '{0} s',
    txt_xiugai: '変更',
    txt_zzjzsj: 'データをロード中',
    txt_bjshxx: '加盟店情報の編集',
    txt_chongxinhq: '再入手する',
    txt_gaibangsj: '携帯の縛りを変える',
    txt_yanzhengjsj: '古い携帯電話を検証する',
    txt_bangdingxsj: '新しい携帯電話を結びつける',
    txt_yhqsyxsjdl: 'これからは新しい番号で登録してください',



    //登录新
    txt_xzshenfen: '身分を選んでください',
    txt_dlrolewz: '{0}番号を登録する',
    txt_qsrsjh: '携帯番号を入力してください',
    txt_zhuce: '登録',
    txt_wanjimima: 'パスワードを忘れた',
    txt_wanshandzxx: '店長のアカウントの資料をもっと詳しく記入する',
    txt_qsrxm: '氏名を入力してください',
    txt_qsrmdm: '店名を入力してください',
    txt_qsrmdgddh: '店の固定電話を入力してください',
    txt_qsrmddz: '店の住所を入力してください',
    txt_qsrgsdz: '会社の住所を入力してください',
    txt_qsrxxdz: '詳しい住所を入力してください',
    txt_tijiaocg: '提出完了',
    txt_qsvbsylwmm: '6桁以上のパスワードを設定してください',
    txt_zhucerole: '注册{0}号',
    txt_qsrshh: '取引先のアカウントを入力してください',
    txt_qsrdzh: '店長のアカウントを入力してください',
    txt_wsshhzl: '取引先アカウントの資料をもっと詳しく記入する',
    txt_wsdyhzl: '店員アカウントの資料をもっと詳しく記入する',
    txt_qsrshm: '取引先名（会社名）を入力してください',
    txt_qsrshz: '取引先のオーナー（責任者）を入力してください',
    txt_qsrzrqy: '请输入责任区域(工作部门)',
    txt_shanghudizhi: '取引先の住所',
    txt_yhycz: 'このユーザーがすでに存在します',
    txt_qsrzqdzh: '正しい店長アカウントを入力してください',
    txt_qsrzqshh: '正しい取引先アカウントを入力してください',
    txt_xzmdcx: '「店の検索」を選ぶ',




    //门店
    txt_mendianId: '店舗ID',
    txt_mendianmc: '店舗名',
    txt_mendiandz: '店の住所',
    txt_mendiandh: '店舗電話',
    txt_caozuo: 'そうさ',
    txt_mendiangl: '店舗管理',
    txt_gjmendian: '共{0}家門店',
    txt_zhengchangyy: '通常営業する',
    txt_tingye: 'きゅうぎょうび',
    txt_gengdxx: 'さらなる情報',
    txt_dianygl: '店員管理',
    txt_biangzt: '状態を変更する',
    txt_qdygbzhuangtai: '店舗{0}の状態を{1}に変更することは確定ですか?',
    txt_bjmendian: '店舗情報の編集',
    txt_xinzenmd: '店舗を増やす',
    txt_qtxmdmc: '店舗名を記入してください',
    txt_qxzmddz: '店の住所を選んでください',
    txt_qtxxdz: '詳しい住所を記入してください',
    txt_xiangxidz: '詳しい住所',
    txt_qtxmddh: '店舗番号を記入してください',
    txt_dzxx: '店長メッセージ',
    txt_chaungjianmendian: '店舗をつくる',
    txt_mendianxxxx: '店舗詳細',
    txt_bianji: '编辑',
    txt_mendianzt: '店舗状態',

    //商户数据总览
    txt_mendianshuju: '店舗データ',
    txt_chakangdxxbb: 'もっと詳細なレポートを見る',
    txt_jczcs: '総検出回数',
    txt_mdpjjc: '店舗平均チェック',
    txt_jdzcl: '入店車両',
    txt_jcl: '検出率',
    txt_msqkjgtj: '摩耗状況の集計結果(タイヤストリップ数',
    txt_xyghltjgfb: 'タイヤ交換の結果分布',
    txt_xzzyltjgfb: 'タイヤの結果分布に注意',
    txt_sldwjgtj: '四4輪ポジショニング結果集計(タイヤストリップ数）',
    txt_xjxsldwfb: '4輪ポジショニングタイヤの結果分布を行う必要がある',
    txt_xzzyjxsldwfb: '4輪ポジショニングタイヤの結果分布に注意',
    txt_jrzl: '今日の総覧',
    txt_xiangqbb: '詳細レポート。',
    txt_xuanzerqckxxsj: '日付を選んで詳細データを見る',
    txt_qxzsjd: '時間帯を選んでください',
    txt_sjdts: '最大30日以内の期間しか選べない',
    txt_zonglan: '総覧する',
    txt_qushi: '趋势',
    txt_shuliangtj: '数量統計',
    txt_syjcjgz: '所有检测结果中，各种磨损情况的轮胎条数及占比',
    txt_mslttsfb: '磨损轮胎条数分布情况',
    txt_msbgslzb: '(不同条数轮胎磨损的报告数量、以及在总检测数中的占比）',
    txt_sldwjlzb: '所有检测结果中，各种四轮定位结论的轮胎条数及占比',
    txt_sldwfbqk: '四轮定位结论条数分布情况',
    txt_btjgsldwzb: '不同条数四轮定位结论的报告数量、以及在总检测数中的占比',
    txt_jccsqs: '検出回数の傾向',
    txt_msqkslqs: 'タイヤの摩耗量の傾向',
    txt_jgfbqushi: '磨耗したタイヤの交換結果の分布傾向',
    txt_msltjgfbqs: '摩耗タイヤはタイヤの結果分布の傾向に注意',
    txt_ltxsldwslqs: 'タイヤ需要4輪ポジショニング状況台数傾向',
    txt_jccs: '検出回数',
    txt_shuliang: 'すうりょう',
    txt_zhanbi: '%',
    txt_chankangd: 'もっと見る',
    txt_chakanmdxxbb: '店舗詳細をチェックする',


    //国家
    txt_zhongguo: '中国',
    txt_mlxy: '马来西亚',
    txt_yindu: '印度',
    txt_taiguo: '泰国',
    txt_oluosi: '俄罗斯',



    txt_taici:'もたらす',
    txt_jianyi:'提案:',
    txt_jianyineirong: 'タイヤに偏りがあります。さらに検査することを提案します',
    txt_jianyineiherongzc:'正常',
    txt_bgtixing:'ちゅうい:',
    txt_bgtuxubfnr:'現在のタイヤの摩耗状況により、新品タイヤと比較してブレーキ距離が{0}%増加しました',
    txt_waishang:'外傷',
    txt_laohua:'エージング',
    txt_gubao:'太鼓のこぶ',
    txt_xichemeirong:'洗車美容',
    txt_weixibbaoyang:'メンテナンス',
    txt_guenghuanluntai:'タイヤ交換',
    txt_scsltjcy:'手持ちタイヤ検出器',
    txt_shijiantishi:'終了時間は開始時間より大きくしなければならない',

    txt_qxzclry: '処理要員を選んでください',

    txt_lf_outworn:'左前胎の外側は内側よりも摩耗がひどい',
    txt_lf_innerworn:'左前胎の内側は外側より摩耗がひどい',
    txt_lf_bothsideworn:'左前胎の両側は中間より摩耗がひどい',
    txt_lf_centreworn:'左前タイヤの中間は両側より摩耗がひどい',
    txt_lb_outworn:'左後胎の外側は内側よりも摩耗がひどい',
    txt_lb_innerworn: '左後胎の内側は外側よりも摩耗がひどい',
    txt_lb_bothsideworn:'左後胎の両側は中間より摩耗がひどい',
    txt_lb_centreworn:'左後胎の中間は両側より摩耗がひどい',
    txt_rb_outworn:'右後胎の外側は内側よりも摩耗がひどい',
    txt_rb_innerworn: '右後胎の内側は外側よりも摩耗がひどい',
    txt_rb_bothsideworn:'右後胎の両側は中間より摩耗がひどい',
    txt_rb_centreworn:'右後胎の中間は両側より摩耗がひどい',
    txt_rf_outworn:'右前胎の外側は内側よりも摩耗がひどい',
    txt_rf_innerworn: '右前胎の内側は外側よりも摩耗がひどい',
    txt_rf_bothsideworn:'右前胎の両側は中間より摩耗がひどい',
    txt_rf_centreworn:'右前胎の中間は両側より摩耗がひどい',
    txt_tire_need_replace:'タイヤの摩耗があったら、すぐに交換します',

    txt_alignment_chassis: '四輪位置決めまたはシャシー検査をさらに行うことを提案します',

    txt_do_further_check: 'さらにチェックしてください',
    txt_uneven_check: 'タイヤの磨耗が異常で、四輪位置決めとシャーシを確認することを提案します',
    txt_tire_rotation:'タイヤの位置変更を推奨します',
    txt_wear_normal:'タイヤの摩耗が正常である',
    'txt_wear_normal;': 'タイヤの摩耗が正常である',
    txt_tire:'タイヤ',
    txt_xiazai:'ダウンロード',
    txt_xiazasishibai:'ダウンロード失敗',
    txt_appname:'Leadshub',
    txt_dianjixiazazadroid:'をクリックしてAndroidをダウンロードします',
    txt_dianjixiaziios:'をクリックしてIosをダウンロードします',





    txt_gelie:'切り裂き',
    txt_diaokuai:'ブロックが取れます',
    txt_chaungci:'穿刺',
    txt_cashang:'擦り傷',
    txt_yichang:'異常',
    txt_qjybjcltazqk:'タイヤ装着状況状況をさらに確認してください',
    txt_wear_overall:'タイヤ摩耗状況',
    txt_pattern_wear:'偏摩耗',
    txt_tire_age:'タイヤ使用期限',
    txt_tire_appearance:'タイヤ外観',
    txt_tire_age_5:'タイヤが生産後、5年を超えました。タイヤの交換を勧めます。',
    txt_tire_age_3:'タイヤが生産後、3年を超えました。定期的に検査してください',
    txt_tire_age_8:'タイヤが生産後、8年を超えました。タイヤの交換を勧めます。',
    txt_tire_age_6:'タイヤが生産後、6年を超えました。定期的に検査してください',
    txt_tire_age_ok:'タイヤの年限が良い',
    txt_tire_trauma_check:'タイヤの表面に外傷があります。さらに検査することを提案します',
    txt_install_abnormal_check:'タイヤ装着状況が逆で、さらに検査することを提案します',
    txt_tire_appearance_ok:'良好',
    txt_ltlcgstm: '現在のタイヤの摩耗状況によると、想定される残りのタイヤ寿命は｛0｝km（予備値）です',
    'txt_tire_need_replace;': 'タイヤがひどく磨耗していますので、タイヤの交換をお勧めします',
    'txt_uneven_check;': 'タイヤの磨耗が異常で、四輪の位置決めとシャーシを確認することを提案します',
    txt_tire_rotation: 'タイヤの交換をお勧めします',
    'txt_tire_age_ok': 'タイヤの年限が良い',
    'txt_wear_uniform;': '単一のタイヤの摩耗が比較的に均一である',
    txt_wear_uniform: '単一のタイヤの摩耗が比較的に均一である',
    'txt_tire_boundary;': 'タイヤの摩耗があります。境界状態です',
    txt_tire_boundary: 'タイヤの摩耗があります。境界状態です',
    txt_plcl:'一括処理',
    txt_qbxz:'全選択',
    txt_scjcjg:'前回の検査結果',
    txt_ltxhlcgs:'タイヤ寿命予測',
    txt_ltazhuang:'タイヤ装着状況:',
    txt_dqltlctx:'現在のタイヤは限界に達しました。直ちにタイヤを交換してください',
    txt_dottx: 'タイヤの耐用年数推定',
    txt_danweinian: '(単位:年)',
    txt_danweikm: '(単位:km)',
    txt_myhqdsj:'DOT時間が取れませんでした。',
    txt_dotjstx:'タイヤ残使用時間は{0}日ぐらいです',
    txt_dotjstx_2:'タイヤの耐用年数が5年を超えました。すぐに交換してください',
    txt_dotsjztx:'(DOT:タイヤ製造日)',
    'txt_tire_age_ok;': 'タイヤの年限が良い',


    //微信公众号
    txt_mdmz: '门店姓名',
    txt_mddzz: '门店地址',
    txt_sbid: '设备ID',
    txt_jsxm: '技師の名前',
    txt_shoujhm: '手机号码',
    txt_dxyzmm: '短信验证码',


    txt_jishimz: '技師',
    txt_ltlcgsnew: '想定される残りのタイヤ寿命は{0}kmです',
    txt_ltlcgsnewin: 'Tire range is {0} miles',
    txt_pinnate_wear: '羽状磨耗',
    txt_msjxtx: 'タイヤが限界に達しましたので、すぐに交換してください',
    xt_ltfz:"内外反'を装着し、",
    txt_install_check:'タイヤ装着状況',
    txt_install_ok:'正常',
    LF:'[左前輪]',
    RF:'[右前輪]',
    LB:'[左後輪]',
    RB:'[右後輪]',
    FF:'[前軸]',
    BB:'[後軸]',
    txt_appearance_check: 'タイヤに外傷があります。修理確認をお願いします',
    txt_uneven_center: 'タイヤの中間磨耗が異常で、タイヤの圧力を確認することを提案します',
    txt_uneven_out: 'タイヤの外側の摩耗異常は、四輪の位置決めとタイヤの圧力を確認することを推奨します',
    txt_pinnate_check: 'タイヤは羽のように磨耗していますので、シャーシの検査を進めてください',
    txt_uneven_inside: 'タイヤの内側の摩耗が異常で、四輪の位置決めとタイヤの圧力を確認することを提案します',
    'txt_do_further_check;': 'さらにチェックしてください',
    txt_uneven_bothside: 'タイヤ二輪の摩耗が異常で、四輪の位置決めとタイヤの圧力を確認することを提案します',

    txt_msyzljgh: 'タイヤの摩耗がひどいので、すぐに交換してください',
    txt_serious_trauma_check: "タイヤに大きな外傷がありますので、タイヤの交換をお勧めします",
    txt_appearance_lookup: "タイヤの外観を確認してください",
    txt_wear_lookup: "タイヤの摩耗状況を確認してください",
    txt_dotscsj: '生産時間：{0}({1}年第{2}週間)',
    txt_whqdscsj: '生産時間が取得されていません',
    purp_tireservice: 'タイヤサービス',
    purp_vehicle_inspection: '車両検査',
    txt_chassis_check :'シャーシ検査',
    txt_chassis_ok:'シャーシの検査が良いです',
    txt_chassis_oil:'ダンパーから油が漏れていますので、さらに確認することをお勧めします。必要な時は交換してください',
    txt_chassis_aging :'ブッシュゴムの劣化は、交換処理を推奨します',
    txt_trauma_eattyre:'チューブを食べる',
    txt_uneven_eattyre:'タイヤはタイヤを食べて、動きのバランスを取ることと、四輪の位置決め、サスペンションシステムを検査することを提案します',
    txt_appearance_eattyre:'タイヤはタイヤを食べて、動きのバランスを取ることと、四輪の位置決め、サスペンションシステムを検査することを提案します。',
    txt_chassis_eattyre:'タイヤはタイヤを食べて、四輪の位置決め、サスペンションシステムを検査することを提案します',
    txt_uneven_high_eattyre:'タイヤがタイヤを大変に食べています。タイヤの交換と四輪の位置決め、サスペンションシステムの検査を勧めています',
    txt_appearance_high_eattyre:'タイヤがタイヤを大変に食べています。動きのバランスと四輪の位置決め、サスペンションシステムをチェックすることを提案します',
    txt_chassis_high_eattyre:'タイヤがタイヤを大変に食べていますので、四輪の位置決め、サスペンションシステムの検査をお勧めします',
    txt_chassis_uneven:'片側のタイヤの摩耗状況が異常なので、アライメント調整、サスペンションシステムの検査を勧めます',
    txt_pianmoyichang:'タイヤバイアス異常',


    txt_khxm:'お客様の名前',
    txt_khyx:'顧客メールボックス',

}


// WEBPACK FOOTER //
// ./src/i18n/ja.js